import { z } from 'zod';

export const AdminUserRoleSchema = z.enum(['ADMIN', 'ASSESSOR']);
export type AdminUserRole = z.infer<typeof AdminUserRoleSchema>;
